<template>
<navBack></navBack>
  <div class="appointment-list">

    <!-- 筛选条件 -->
    <div class="filter-section">
      <t-tabs v-model="activeTab" @change="onTabChange">
        <t-tab-panel value="0" label="全部" />
        <t-tab-panel value="1" label="待确认" />
        <t-tab-panel value="2" label="已确认" />
        <t-tab-panel value="3" label="已完成" />
        <t-tab-panel value="4" label="已取消" />
      </t-tabs>
    </div>
    
    <!-- 预约列表 -->
    <div class="list-section" v-if="appointmentList.length > 0">
      <block v-for="(item, index) in appointmentList" :key="index">
        <t-card class="appointment-item" @click="divAppointmentDetail(item)">
          <template #title>
            <div class="item-header">
              <text class="customer-name">{{ item.customerName }}</text>
              <text class="status" :class="getStatusClass(item.status)">
                {{ getStatusText(item.status) }}
              </text>
            </div>
          </template>
          <template #content>
            <div class="item-content">
              <div class="info-row">
                <t-icon name="calendar" />
                <text class="info-text">{{ formatDateTime(item.appointmentTime) }}</text>
              </div>
              <div class="info-row">
                <t-icon name="location" />
                <text class="info-text">{{ item.serviceName }}</text>
              </div>
              <div class="info-row">
                <t-icon name="phone" />
                <text class="info-text">{{ item.customerPhone }}</text>
              </div>
            </div>
          </template>
          <template #footer>
            <div class="item-footer">
              <t-button 
                v-if="item.status === 0" 
                size="small" 
                theme="primary" 
                variant="outline"
                @click.stop="confirmAppointment(item)"
              >
                确认预约
              </t-button>
              <t-button 
                v-if="item.status === 1" 
                size="small" 
                theme="default" 
                variant="outline"
                @click.stop="completeAppointment(item)"
              >
                完成预约
              </t-button>
            </div>
          </template>
        </t-card>
      </block>
    </div>
    
    <!-- 空状态 -->
    <div class="empty-section" v-else>
      <t-empty
        image="https://tdesign.gtimg.com/miniprogram/images/empty1.png"
        description="暂无预约信息"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRoute,useRouter } from 'vue-router'
import navBack  from '@/components/nav-back.vue'
const customer_Id = ref('');

// 路由实例
const route= useRoute()
const router = useRouter()

// 响应式数据
const activeTab = ref('0')
const appointmentList = ref([])

// 状态映射
const statusMap = {
  0: { text: '待确认', class: 'pending' },
  1: { text: '已确认', class: 'confirmed' },
  2: { text: '已完成', class: 'completed' },
  3: { text: '已取消', class: 'cancelled' }
}

// 获取状态文本
const getStatusText = (status) => {
  return statusMap[status]?.text || '未知状态'
}

// 获取状态样式类
const getStatusClass = (status) => {
  return statusMap[status]?.class || ''
}

// 格式化日期时间
const formatDateTime = (date) => {
  // 实现日期格式化逻辑
  return new Date(date).toLocaleString()
}

// 标签切换
const onTabChange = (value) => {
  activeTab.value = value
  loadAppointmentList()
}

// 查看预约详情
const divAppointmentDetail = (appointment) => {
  router.push({
    path: '/appointmentDetail',
    query: { id: appointment.id }
  })
}

// 确认预约
const confirmAppointment = (appointment) => {
  // 实现确认预约逻辑
  console.log('确认预约:', appointment)
}

// 完成预约
const completeAppointment = (appointment) => {
  // 实现完成预约逻辑
  console.log('完成预约:', appointment)
}

// 加载预约列表
const loadAppointmentList = async () => {
  try {
    // 这里应该调用实际的API获取预约数据
    // 示例数据
    appointmentList.value = [
      {
        id: '1',
        customerName: '张三',
        customerPhone: '13800138000',
        serviceName: ' haircut',
        appointmentTime: '2023-06-01 14:00',
        status: 0
      },
      {
        id: '2',
        customerName: '李四',
        customerPhone: '13900139000',
        serviceName: 'facial',
        appointmentTime: '2023-06-02 10:00',
        status: 1
      }
    ]
  } catch (error) {
    console.error('获取预约列表失败:', error)
  }
}

// 组件挂载时加载数据
onMounted(() => {
  customer_Id.value=route.query.id;
  loadAppointmentList()
})
</script>

<style scoped>
.appointment-list {
  
  min-height: 100vh;
}

.page-header {
  background-color: #fff;
  padding: 30rpx 20px;
  border-bottom: 1rpx solid #eee;
}

.page-title {
  font-size: 36px;
  font-weight: bold;
  color: #333;
}

.filter-section {
  background-color: #fff;
  margin-bottom: 20px;
}

.appointment-item {
  margin: 20px;
  border-radius: 16px;
  overflow: hidden;
}

.item-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.customer-name {
  font-size: 32px;
  font-weight: bold;
  color: #333;
}

.status {
  font-size: 24px;
  padding: 6rpx 12px;
  border-radius: 8px;
}

.status.pending {
  background-color: #fff3cd;
  color: #856404;
}

.status.confirmed {
  background-color: #d4edda;
  color: #155724;
}

.status.completed {
  background-color: #d1ecf1;
  color: #0c5460;
}

.status.cancelled {
  background-color: #f8d7da;
  color: #721c24;
}

.item-content {
  padding: 10rpx 0;
}

.info-row {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.info-row:last-child {
  margin-bottom: 0;
}

.info-text {
  margin-left: 10px;
  font-size: 28px;
  color: #666;
}

.item-footer {
  display: flex;
  justify-content: flex-end;
  padding-top: 20px;
}

.empty-section {
  padding-top: 200px;
}
</style>